/*
 *   File : password.js
 *   Author : https://evoqins.com
 *   Description : Password Input component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { memo, useState, useRef } from "react";

//custom style
// import styles from "../../Style/Components/input.module.scss";

// Assets
import showIcon from "../../Assets/Images/Components/show.svg" ;
import hideIcon from "../../Assets/Images/Components/hide.svg";
import { formatInputErrorMessage } from "../../Utils/format-input-error";

const CustomPasswordInput = (props) => {
  const inputRef = useRef(null);
  const [show, setShow] = useState(false);

  //input handle change
  const _handleChange = (e) => {
    let value = e.target.value;
    props.handleChange(value);
  };

  // handle enter key press (guard: optional handler; defaultProps unreliable on memo in newer React)
  const _keyPress = (e) => {
    if (e.key === "Enter" && typeof props.onKeyPress === "function") {
      props.onKeyPress();
    }
  };

  // handle show and hide password
  const _handleShow = () => {
    setShow(!show);
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
        inputRef.current.setSelectionRange(
          inputRef.current.value.length,
          inputRef.current.value.length
        );
      }, 0);
    }
  };

  return (
    <div>
      {props.label && (
        <label
          className={`${
            props.labelStyle
              ? props.labelStyle
              : " fw-400  fs-14 lh-18 "
          }  text-eerie-black pb-1`}
        >
          {props.label}
          {props.require && <span className="text-cg-red">*</span>}
        </label>
      )}

      <div className="h-64">
        <div className={`position-relative`}>
          <input
            id={props.id}
            ref={inputRef}
            value={props.value}
            defaultValue={props.defaultValue}
            maxLength={props.maxLength}
            tabIndex={props.tabIndex}
            autoFocus={props.autoFocus}
            type={show ? "text" : "password"}
            required={props.required}
            readOnly={props.readOnly}
            placeholder={props.placeholder}
            className={`${props.error ? "e-border-error" : "border-transparent e-border-input"} ${
              props.className
            }  e-password-input  fw-400 `}
            onWheel={() => document.activeElement.blur()}
            // onFocus={_handleFocus}
            // onBlur={_handleBlur}
            onChange={_handleChange}
            onKeyDown={(e) => _keyPress(e)}
            onClick={props.onClick}
          />

          <img
            src={show ? showIcon : hideIcon}
            draggable={false}
            className="e-cursor-pointer position-absolute e-password-img"
            width={16}
            alt="icon"
            onClick={_handleShow}
          />
        </div>
        {props.error && (
          <p className="mb-0 fs-12 text-cg-red pt-1">
            {formatInputErrorMessage(props.error)}
          </p>
        )}
      </div>
    </div>
  );
};

CustomPasswordInput.defaultProps = {
  onKeyPress: () => {},
  className: null,
  error: "",
};

export default memo(CustomPasswordInput);
